import { Icon, ospThemes } from "@ospweb/sdk-ui";

import { EdgenModalCreateAble } from "../EdgenModal";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/modal/CommonConfirmModal";
import { cn } from "utils";
import { useState } from "react";

const I18n = I18nUtil.createScoped(Translations);

/**
 *  通用的二次确认弹窗
 */
type CommonConfirmModalProps = {
  title: string;
  description: string;
  loading?: boolean;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  showClose?: boolean;
  className?: string;
  cancelTestId?: string;
  confirmTestId?: string;
  cancelTrackingEventName?: string;
  cancelTrackingEventKeys?: Record<string, string | undefined>;
};

const CommonConfirmModal = (props: CommonConfirmModalProps) => {
  const {
    onClose,
    onConfirm,
    title,
    description,
    showClose = true,
    className,
    cancelTestId,
    confirmTestId,
    cancelTrackingEventName,
    cancelTrackingEventKeys,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  };
  return (
    <div
      className={cn(
        "px-6 pt-6 pb-3 bg-background_solid_secondary flex flex-col gap-6",
        className,
      )}
    >
      <div className="flex flex-col gap-2">
        <div className="headline_regular_s text-content_primary">{title}</div>
        <div className="body_m text-content_secondary">{description}</div>
      </div>
      <div className="flex gap-2 justify-end">
        {showClose && (
          <button
            aria-label="Common Confirm Modal"
            data-openreplay-label="common_commonconfirmmodal_click"
            id="btn-common-confirm-modal"
            data-testid={cancelTestId}
            data-tracking-eventname={cancelTrackingEventName}
            data-tracking-event-key-tracker_id={
              cancelTrackingEventKeys?.tracker_id
            }
            className="sm_button button secondary_button text-content_primary button_m"
            disabled={isLoading}
            onClick={onClose}
          >
            {I18n.t("Cancel")}
          </button>
        )}
        <button
          aria-label="Common Confirm Modal"
          data-openreplay-label="common_commonconfirmmodal_submit"
          id="btn-common-confirm-modal-2"
          data-testid={confirmTestId}
          className="sm_button min-w-[80px] button primary_button text-content_inverse_primary button_m group"
          data-loading={isLoading}
          onClick={handleConfirm}
        >
          <span className="group-loading:hidden">{I18n.t("Confirm")}</span>
          <Icon
            name="ic_loading2"
            size={20}
            color={ospThemes.colors.content_inverse_primary}
            className={cn("hidden animate-spin group-loading:block")}
          />
        </button>
      </div>
    </div>
  );
};

export const CommonConfirmModalCallable = async (props: any) => {
  const { modalProps, ...otherProps } = props;
  return new Promise<any>((resolve) => {
    EdgenModalCreateAble.call({
      children: (
        <CommonConfirmModal
          onClose={() => {
            EdgenModalCreateAble.end(false);
            resolve(undefined);
          }}
          {...otherProps}
          onConfirm={() => {
            EdgenModalCreateAble.end(true);
            otherProps.onConfirm();
          }}
        />
      ),
      onCancel: () => EdgenModalCreateAble.end(false),
      containerClassName:
        "!w-[320px] !max-w-[calc(100vw-32px)] !md:w-[400px] !md:max-w-none !md:rounded-[16px]",
      styles: {
        content: {
          backgroundColor: ospThemes.colors.background_solid_secondary,
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        wrapper: {
          zIndex: 10001,
        },
        mask: {
          zIndex: 10001,
        },
      },
      centered: true,
      destroyOnClose: true,
      ...modalProps,
    });
  });
};
